module.exports = __webpack_public_path__ + "fonts/font.badab5cb.woff2";